import { Component, inject, OnInit, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { OfficialViewService } from '../../official-view.service';
import { Match } from '../../../_shared/models/match.model';

@Component({
  selector: 'app-swap-side',
  templateUrl: './swap-side.component.html',
  styleUrls: ['./swap-side.component.scss'],
  standalone: true,
  imports: [
    IonicModule
  ]
})
export class SwapSideComponent{
  officialViewService = inject(OfficialViewService);

  @Input({ required: true }) match!: Match;

}
